
import * as yup from "yup";
import { Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { PropType } from "vue";
import { Field, Form, FormActions } from "vee-validate";
import FormMixin from "../../helpers/mixins/form";
import ActionButton from "../atoms/ActionButton.vue";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import { AuthApi, OperationRangesEnum } from "../../autogen";
import HelpIcon from "../atoms/HelpIcon.vue";

interface StrKeyObject {
  [key: string]: any;
}

interface FormValue {
  name: string;
  operationRange: keyof typeof OperationRangesEnum | "none";
  permissions: StrKeyObject;
}

@Options({
  components: { ActionButton, Field, Form, FieldError, FormError, HelpIcon }
})
export default class AuthorityForm extends FormMixin {
  globalErrors: { message: string }[] = [];
  validationSchema!: yup.AnyObjectSchema;
  formName = "権限";
  @Prop({ type: String }) mode: "add" | "edit" = "add";
  @Prop({ type: Array as PropType<Array<Object>> }) headers = [];
  formValue: FormValue = {
    name: "",
    operationRange: "none",
    permissions: {
      employee: [],
      applicant: [],
      analysis: [],
      manage: [],
      specialManage: [],
      asBroadcast: [],
      employeeStats: [],
      applicantStats: []
    }
  };
  @Prop({ type: String }) selectedPermissionId = "";

  get operationRanges() {
    return Object.assign({ none: "" }, OperationRangesEnum);
  }

  updateFormValue(type: string, permission: string) {
    if (this.formValue.permissions[type].includes(permission)) {
      this.formValue.permissions[type] = this.formValue.permissions[type].filter((p: string) => p !== permission);
    } else {
      this.formValue.permissions[type].push(permission);
    }
  }

  async onDeleteButtonClick() {
    this.onDelete(async () => {
      await new AuthApi().deleteRole({
        id: this.selectedPermissionId
      });
      this.$emit("delete");
    }, "権限を削除します。よろしいでしょうか？");
  }

  async beforeCreate() {
    this.validationSchema = yup.object({
      name: yup.string().required(this.$t("input_required", { field: "権限名" })),
      operationRange: yup
        .mixed()
        .oneOf(Object.keys(OperationRangesEnum), this.$t("input_required", { field: "範囲" }))
        .required()
    });
  }

  async onBeforeSubmit(value: FormValue) {
    this.formValue.name = value.name;
    this.formValue.operationRange = value.operationRange;
    await this.onSubmit(async () => {
      if (this.mode === "add") {
        await new AuthApi().createRole({
          roleRequest: {
            name: this.formValue.name,
            operationRange: this.formValue.operationRange,
            permissions: this.formValue.permissions
          }
        });
      } else if (this.mode === "edit") {
        await new AuthApi().updateRole({
          id: this.selectedPermissionId,
          roleRequest: {
            name: this.formValue.name,
            operationRange: this.formValue.operationRange,
            permissions: this.formValue.permissions
          }
        });
      }
      this.$emit("confirm");
      this.clearForm();
    });
  }
  setFormValue(value: FormValue) {
    this.globalErrors = [];
    this.formValue = value;
  }
  clearForm() {
    if (!this.$refs.form) return;
    const formValidation = this.$refs.form as FormActions<yup.AnyObjectSchema>;
    formValidation.resetForm();
  }
}
